"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = void 0;
const tree_node_1 = require("./tree.node");
class Tree {
    // ast entry point
    _root;
    // this stores a map linking antlr original nodes to the ast nodes
    allNodes;
    // stores a map linking each char position to the ast node that contains it
    positionContextMap;
    tokenContextMap;
    constructor(rootNode) {
        if (rootNode)
            this._root = rootNode;
        this.allNodes = new Map();
        this.positionContextMap = new Map();
        this.tokenContextMap = new Map();
    }
    getFormulaArgs() {
        if (!this._root)
            return [];
        if (this._root.treeNodeType === tree_node_1.TreeNodeType.FORMULA_NODE) {
            return this._root.children.map(child => child.toString() ?? '');
        }
        return [];
    }
    getContextAtPosition(position) {
        const formulaCtx = this.positionContextMap.get(position);
        const leafCtx = this.tokenContextMap.get(position);
        return { formulaContext: formulaCtx, leafContext: leafCtx };
    }
    get root() {
        return this._root;
    }
    set root(root) {
        this._root = root;
    }
    // add new entry altr_node -> ast_node to the map
    setToNodesToMap(originalNode, node) {
        this.allNodes.set(originalNode, node);
        // @ts-ignore
        if (node.isLeaf) {
            const startPosition = node.startPosition;
            const endPosition = node.endPosition;
            if (startPosition === undefined || endPosition === undefined)
                return;
            for (let i = startPosition; i <= endPosition; i++) {
                this.tokenContextMap.set(i, node);
            }
            return;
        }
        const startPosition = node.argsStartPosition;
        const endPosition = node.argsEndPosition;
        if (startPosition === undefined || endPosition === undefined)
            return;
        for (let i = startPosition; i <= endPosition; i++) {
            this.positionContextMap.set(i, node);
        }
        const formulaNameStartPosition = node.tokenStartPosition;
        const formulaNameEndPosition = node.tokenEndPosition;
        if (formulaNameStartPosition === undefined || formulaNameEndPosition === undefined)
            return;
        for (let i = formulaNameStartPosition; i <= formulaNameEndPosition; i++) {
            this.tokenContextMap.set(i, node);
        }
    }
    getNodesFromMap(originalNode) {
        return this.allNodes.get(originalNode);
    }
    // generates a string representation of the ast(also adds concrete nodes)
    toString() {
        return this._root?.toString();
    }
    // links all nodes to their parents/childrens
    createLinks() {
        this.root?.init(this.allNodes);
    }
    translate(opts) {
        return this._root?.translate(opts) ?? '';
    }
    getReturnType() {
        if (!this._root)
            return undefined;
        return this._root.getReturnType();
    }
    isWindowFunction() {
        if (this.root?.treeNodeType === tree_node_1.TreeNodeType.FORMULA_NODE) {
            const formulaNode = this.root;
            return formulaNode.formulaData?.isWindowFunction ?? false;
        }
        return false;
    }
}
exports.Tree = Tree;
